import { render } from "./PasteTextModal.vue?vue&type=template&id=66481592&scoped=true"
import script from "./PasteTextModal.vue?vue&type=script&lang=js"
export * from "./PasteTextModal.vue?vue&type=script&lang=js"

import "./PasteTextModal.vue?vue&type=style&index=0&id=66481592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66481592"]])

export default __exports__